<template>
<div class="site-drawer">
  Testo a caso
</div>
</template>

<script>
export default {
  name: 'site-drawer',
}
</script>
